import {
  Avatar,
  Backdrop,
  Box,
  Button,
  Grid,
  List,
  ListItem,
  Paper,
  Snackbar,
  Stack,
  Tab,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tabs,
  Typography,
} from "@mui/material";
import NOprofileImage from "../../public/assets/images/no-image.svg";

import React, { useCallback, useState } from "react";
import styles from "../../styles/pages/editors.module.scss";
import assest from "../../json/assest";
import EditorsLargeModal from "../../ui/Modal/EditorsLargeModal";
//   import Image from "next/image";
//   import VideoIcon from "@/ui/Icons/VideoIcon";
import AnalyticsIcon from "../../ui/Icons/AnalyticsIcon";
import ProfileIcon from "../../ui/Icons/ProfileIcon";
import NotificationLeftFilter from "../NotificationLeftFilter/NotificationLeftFilter";
import VideosummaryCard from "../VideosummaryCard/VideosummaryCard";
import EditorMoadlTable from "../EditorMoadlTable/EditorMoadlTable";
import CopywritersModalTable from "../CopywritersModalTable/CopywritersModalTable";
import Pagination from "../UtilitiesComponent/Pagination";
import EditorsCopywritersProfileTab from "../EditorsCopywritersProfileTab/EditorsCopywritersProfileTab";
import HomeIcon from "../../ui/Icons/HomeIcon";
import RoundCheckIcon from "../../ui/Icons/RoundCheckIcon";
import RoundTickIcon from "../../ui/Icons/RoundTickIcon";
import TabArrowIcon from "../../ui/Icons/TabArrowIcon";
import ModaltableHeader from "../ModaltableHeader/ModaltableHeader";
import QcModalTable from "../QcModalTable/QcModalTable";
import PerfectScrollbar from "react-perfect-scrollbar";
import "react-perfect-scrollbar/dist/css/styles.css";
import InfomarkIcon from "../../ui/Icons/InfomarkIcon";
import WebsiteIcon from "../../ui/Icons/WebsiteIcon";
import BookmarkIconSm from "../../ui/Icons/BookmarkIconSm";
import DuplicateIcon from "../../ui/Icons/DuplicateIcon";
//   import ManagersModalTable from "../ManagersModalTable/ManagersModalTable";
//   import AssignRadioCard, {
//     assignRadioProps,
//   } from "../AssignRadioCard/AssignRadioCard";
import QCModalWebsiteonlyTable from "../QcModalTable/QCModalWebsiteonlyTable";
import QCModalRejectedTable from "../QcModalTable/QCModalRejectedTable";
import QCModalDeniedApprovedRejectedTable from "../QcModalTable/QCModalDeniedApprovedRejectedTable";
import QCModalDeniedApprovedwebsiteTable from "../QcModalTable/QCModalDeniedApprovedwebsiteTable";
import QCModalDeniedRejectedApprovedTable from "../QcModalTable/QCModalDeniedRejectedApprovedTable";
import QCModalDeniedRejectedwebsiteTable from "../QcModalTable/QCModalDeniedRejectedwebsiteTable";
import QCModalDeniedWebsiteApprovedTable from "../QcModalTable/QCModalDeniedWebsiteApprovedTable";
import QCModalDeniedWebsiteRejectedTable from "../QcModalTable/QCModalDeniedWebsiteRejectedTable";
import LongArrowIcon from "../../ui/Icons/LongArrowIcon";
import EditorUserCreateTab from "../UserCreateTab/EditorUserCreateTab";
import TipaltiPartnerCard from "../TipaltiPartnerCard/TipaltiPartnerCard";
//   import ManagersDuplicateVideoTable from "../ManagersModalTable/ManagersDuplicateVideoTable";
//   import ManagerConfirmedApprovedApprovedTable from "../ManagersModalTable/ManagerConfirmedApprovedApprovedTable";
//   import ManagerConfirmedWebsiteTable from "../ManagersModalTable/ManagerConfirmedWebsiteTable";
//   import ManagerConfirmedRejectTable from "../ManagersModalTable/ManagerConfirmedRejectTable";
//   import ManagerDeniedApprovedRejectedTable from "../ManagersModalTable/ManagerDeniedApprovedRejectedTable";
//   import ManagerDeniedApprovedWebsiteTable from "../ManagersModalTable/ManagerDeniedApprovedWebsiteTable";
//   import ManagerDeniedRejectedApprovedTable from "../ManagersModalTable/ManagerDeniedRejectedApprovedTable";
//   import ManagerDeniedRejectedWebsiteTable from "../ManagersModalTable/ManagerDeniedRejectedWebsiteTable";
//   import ManagerDeniedWebsiteApprovedTable from "../ManagersModalTable/ManagerDeniedWebsiteApprovedTable";
//   import ManagerDeniedWebsiteRejectedTable from "../ManagersModalTable/ManagerDeniedWebsiteRejectedTable";
import { useQuery } from "react-query";
import {
  EditorUserDeatilsutation,
  EditorVIDEOMutation,
} from "../../api/functions/editor.api";
import { number } from "yup/lib/locale";
import { submissionsList } from "../../api/functions/cms.api";
import SelectMonth from "../SelectMonth/SelectMonth";
import SelectYear from "../SelectYear/SelectYear";
import QcUserCreateTab from "../UserCreateTab/QcUserCreateTab";
import moment from "moment";
import {
  concatHostAndImagePath,
  getStyledShortDate,
} from "../../lib/functions/utils.lib";
import { QCVIDEOMutation } from "../../api/functions/qc.api";
import QcConfirmVideo from "../qcConfirmVIdeo/QcConfirmVideo";
import QcDeniedVideo from "../qcDeniedvideo/QcDeniedVideo";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const videoOptioncard = [
  {
    cardIcon: <InfomarkIcon />,
    title: "Inquiring Videos",
    cardNo: "150",
  },
  {
    cardIcon: <RoundCheckIcon />,
    title: "Approved Videos",
    cardNo: "150",
  },
  {
    cardIcon: <WebsiteIcon />,
    title: "Website Only",
    cardNo: "150",
  },
  {
    cardIcon: <RoundTickIcon />,
    title: "Rejected Videos",
    cardNo: "150",
  },
];

const SearchEditorCard = (props) => {
  const [openEditorsLargeModal, setOpenEditorsLargeModal] =
    React.useState(false);

  const handleOpenCommonModal = useCallback(() => {
    {
      const cardGridLoop = [
        {
          videoTitle: "Validation Summary",
          children: [
            {
              listName: "All videos",
              videoCount: "580",
            },
            {
              listName: "Confirmed",
              videoCount: "420",
            },
            {
              listName: "Denied",
              videoCount: "10",
            },
          ],
        },
        {
          videoTitle: "Pending Validation",
          children: [
            {
              listName: "Approved",
              videoCount: "200",
            },
            {
              listName: "Website Only",
              videoCount: "15",
            },
            {
              listName: "Rejected",
              videoCount: "120",
            },
          ],
        },
      ];
      props?.cardType === "info"
        ? setOpenEditorsLargeModal(true)
        : props?.cardType === "for_copywriter"
          ? setOpenCopywritterLargeModal(true)
          : props?.cardType === "for_qc"
            ? setOpenQcLargeModal(true)
            : props?.cardType === "for_manager"
              ? setOpenManagerLargeModal(true)
              : null;
    }
  }, [openEditorsLargeModal]);

  const handleCloseEditorsLargeModal = useCallback(() => {
    setOpenEditorsLargeModal(false);
  }, []);

  const [openCopywritterLargeModal, setOpenCopywritterLargeModal] =
    React.useState(false);

  const handleCloseCopywritterLargeModal = useCallback(() => {
    setOpenCopywritterLargeModal(false);
  }, []);

  const [openQcLargeModal, setOpenQcLargeModal] = React.useState(false);

  const handleCloseQcLargeModal = useCallback(() => {
    setOpenQcLargeModal(false);
  }, []);

  const [openManagerLargeModal, setOpenManagerLargeModal] =
    React.useState(false);

  const handleCloseManagerLargeModal = useCallback(() => {
    setOpenManagerLargeModal(false);
  }, []);

  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const [innerTab, setInnerTab] = React.useState(0);

  const handleChange2 = (event, newValue) => {
    setInnerTab(newValue);
  };

  const [dinedTab, setdinedTab] = React.useState(0);

  const handleChange3 = (event, newValue) => {
    setdinedTab(newValue);
  };

  const [confimvdoTab, setConfimvdoTab] = React.useState(0);

  const handleChange4 = (event, newValue) => {
    setConfimvdoTab(newValue);
  };

  const [deniedvdoTab, setdeniedvdoTab] = React.useState(0);

  const handleChange5 = (event, newValue) => {
    setdeniedvdoTab(newValue);
  };

  const [snackOpen, setSnackOpen] = React.useState(false);
  const [snackOpen1, setSnackOpen1] = React.useState(false);

  const handleClick = () => {
    setSnackOpen(true);
  };

  const handleClick1 = () => {
    setSnackOpen1(true);
  };
  // const [index, setIndex] = useState("1");

  const handlepageNo = (index) => {
    // setIndex();
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setSnackOpen(false);
  };

  const handleClose1 = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnackOpen1(false);
  };
  const [page, setPage] = useState(1);

  const handleDataFromChild = (e) => {
    setPage(e);
    // Do something with the data received from the child component
  };
  const dasda = {
    selectedId: props.selectedId,
    page: page,
  };
  // const { data: VIDEOList, isLoading } = useQuery(

  //   ["VIDEOList", props.selectedId, page],

  //   async () => {
  //     return QCVIDEOMutation({ editor_id: props.selectedId, page: page });
  //   }
  // );

  const [startDate, setStartDate] = React.useState({
    month: "",
    year: "",
  });
  const handleChildData = (anchorEl) => {
    if (anchorEl.month) {
      setStartDate({ ...startDate, month: anchorEl.month });
    } else if (anchorEl.year) {
      setStartDate({ ...startDate, year: anchorEl.year });
    }
  };
  const { data: submissionsListData } = useQuery(
    ["submissionsList", props.selectedId],
    async () =>
      submissionsList({
        quality_team_id: props.selectedId,
      })
  );

  const analyticsLoop = [
    {
      videoTitle: "Confirmed Videos",
      countVideo: submissionsListData?.data?.confirmed_videos?.total,
      children: [
        {
          listName: "Approved",
          videoCount:
            submissionsListData?.data?.confirmed_videos?.approved_approved,
          listname2: "Approved",
        },
        {
          listName: "Rejected",
          videoCount:
            submissionsListData?.data?.confirmed_videos?.rejected_rejected,
          listname2: "Rejected",
        },
        {
          listName: "Website Only",
          videoCount:
            submissionsListData?.data?.confirmed_videos?.website_website,
          listname2: "Website Only",
        },
      ],
    },
    {
      videoTitle: "Denied Videos",
      countVideo: submissionsListData?.data?.denied?.total,
      children: [
        {
          listName: "Approved",
          videoCount: submissionsListData?.data?.denied?.approved_rejected,
          listname2: "Rejected",
        },
        {
          listName: "Approved",
          videoCount: submissionsListData?.data?.denied?.approved_website,
          listname2: "Website Only",
        },
        {
          listName: "Rejected",
          videoCount: submissionsListData?.data?.denied?.rejected_approved,
          listname2: "Approved",
        },
        {
          listName: "Rejected",
          videoCount: submissionsListData?.data?.denied?.rejected_website,
          listname2: "Website Only",
        },
        {
          listName: "Website Only",
          videoCount: submissionsListData?.data?.denied?.website_approved,
          listname2: "Approved",
        },
        {
          listName: "Website Only",
          videoCount: submissionsListData?.data?.denied?.website_rejected,
          listname2: "Rejected",
        },
      ],
    },
  ];

  return (
    <>
      <Paper
        className={styles.srchCardPaper}
        onClick={() => handleOpenCommonModal()}
      >
        <Stack
          direction={"row"}
          flexWrap={"wrap"}
          className={styles.cardgrid}
          onClick={props.onClick}
        >
          {/* <Avatar
            alt="Viral Snare"
            src={concatHostAndImagePath(props?.avatar)}
            sx={{ width: 52, height: 52 }}
          /> */}

         {/*  {props?.fullitem?.avatar !== "" ? (
            <>
              <Avatar
                alt=""
                // src={assest.vsMain}
                src={concatHostAndImagePath(props?.fullitem?.avatar)}
                sx={{ width: 52, height: 52 }}
              />
            </>
          ) : (
            <>
              <Avatar
                alt=""
                // src={assest.vsMain}
                src={NOprofileImage}
                sx={{ width: 52, height: 52 }}
              />
            </>
          )} */}
          {props?.fullitem?.avatar === "users/default.png" ? (
            <>
              <Avatar
                alt=""
                // src={assest.vsMain}
                src={NOprofileImage}
                sx={{ width: 52, height: 52 }}
              />
            </>
          ) : (
            <>
              <Avatar
                alt=""
                // src={assest.vsMain}
                src={concatHostAndImagePath(props?.fullitem?.avatar)}
                sx={{ width: 52, height: 52 }}
              />
            </>
          )}

          <Box className={styles.userDetails}>
            <List>
              <ListItem>
                <Typography variant="h3">{props?.name}</Typography>
              </ListItem>
              <ListItem>
                <Typography variant="caption">
                  QC Agent since:
                  {props?.fullitem?.joined_at === null ||
                    props?.fullitem?.joined_at === "" ? (
                    <>(Pending Invitation) </>
                  ) : (
                    <> {getStyledShortDate(props?.editorDate)}</>
                  )}
                  {/* {getStyledShortDate(props?.editorDate)} */}
                </Typography>
              </ListItem>
              <ListItem>
                <Typography variant="body1">
                  Email Address: <span>{props?.email}</span>
                </Typography>
              </ListItem>
              {/* {props?.assignAccount && (
                  <ListItem>
                    <Typography variant="body1">
                      Assigned Accounts: <span>{props?.assignNo}</span>
                    </Typography>
                  </ListItem>
                )} */}
              <ListItem>
                <Typography variant="body1">
                  {props?.videoFor} Videos: <span>{props?.totalVideo}</span>
                </Typography>
              </ListItem>
            </List>
            {props.cardType === "for_qc" ? (
              <Box className={styles.cardAlert}>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  className={`${styles.textDenied} ${styles.stackStyled}`}
                >
                  <img
                    src={assest.iconDenied}
                    width={16}
                    height={16}
                    alt="icon"
                  />
                  <Typography variant="body1">
                    Denied Decisions:
                    <span>{props.fullitem?.quality_declined}</span>
                  </Typography>
                </Stack>
                <Stack
                  direction={"row"}
                  alignItems={"center"}
                  flexWrap={"wrap"}
                  className={`${styles.textConfirm} ${styles.stackStyled}`}
                >
                  <img
                    src={assest.iconConfirm}
                    width={16}
                    height={16}
                    alt="icon"
                  />
                  <Typography variant="body1">
                    Confirmed Decisions:
                    <span>{props.fullitem?.quality_confirm}</span>
                  </Typography>
                </Stack>
              </Box>
            ) : null}
          </Box>

          {props.fullitem?.status === 1 ? (
            <Box className={`${styles.resultStatus} ${styles.success}`}>
              Active
            </Box>
          ) : props.fullitem?.status === 0 ? (
            <Box className={`${styles.resultStatus} ${styles.inactive}`}>
              Inactive
            </Box>
          ) : null}
        </Stack>
        {props?.assignAccount && (
          <Stack
            direction={"row"}
            flexWrap={"wrap"}
            alignItems={"center"}
            className={styles.videoOption}
          >
            {videoOptioncard.map((option) => {
              return (
                <Paper elevation={0} className={styles.optionRowList}>
                  <figure>{option?.cardIcon}</figure>
                  <Box className={styles.queryRight}>
                    <Typography variant="body1">{option?.title}</Typography>
                    <Typography variant="caption">{option?.cardNo}</Typography>
                  </Box>
                </Paper>
              );
            })}
          </Stack>
        )}
      </Paper>

      {/* ================================================================= */}
      {/* ============= FOR QC AGENTS PAGE MODAL DESIGN START ============= */}

      <EditorsLargeModal
        open={openQcLargeModal}
        onClose={handleCloseQcLargeModal}
      >
        <Stack
          direction={"row"}
          alignItems={"center"}
          justifyContent={"space-between"}
          flexWrap={"wrap"}
          className={styles.editorModalHeader}
        >
          <Stack
            direction={"row"}
            alignItems={"center"}
            flexWrap={"wrap"}
            className={styles.PfMediaBody}
          >
            {/* {props?.fullitem?.avatar !== "" ? (
              <>
                <Avatar
                  alt=""
                  // src={assest.vsMain}
                  src={concatHostAndImagePath(props?.fullitem?.avatar)}
                  sx={{ width: 52, height: 52 }}
                />
              </>
            ) : (
              <>
                <Avatar
                  alt=""
                  // src={assest.vsMain}
                  src={NOprofileImage}
                  sx={{ width: 52, height: 52 }}
                />
              </>
            )} */}
            {props?.fullitem?.avatar === "users/default.png" ? (
            <>
              <Avatar
                alt=""
                // src={assest.vsMain}
                src={NOprofileImage}
                sx={{ width: 52, height: 52 }}
              />
            </>
          ) : (
            <>
              <Avatar
                alt=""
                // src={assest.vsMain}
                src={concatHostAndImagePath(props?.fullitem?.avatar)}
                sx={{ width: 52, height: 52 }}
              />
            </>
          )}
            <Box className={styles.profileMediaRight}>
              {/* <Typography variant="body1">John Martin</Typography> */}
              <Typography variant="body1">
                {props.fullitem?.name} {props.fullitem?.last_name}
              </Typography>

              <Typography variant="caption">
                {props.fullitem?.role.display_name === "Quality Team" &&
                  "QC Agent "}
              </Typography>
            </Box>
          </Stack>
          <Stack className={`${styles.tabsFlex} ${styles.calcWidth2}`}>
            <Box className={styles.scrollTabs}>
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label="basic tabs example"
              >
                <Tab
                  icon={
                    <span>
                      <HomeIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Home"
                  {...a11yProps(0)}
                />
                <Tab
                  icon={
                    <span>
                      <RoundCheckIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Confirmed Videos"
                  {...a11yProps(1)}
                />
                <Tab
                  icon={
                    <span>
                      <RoundTickIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Denied Videos"
                  {...a11yProps(2)}
                />
                <Tab
                  icon={
                    <span>
                      <AnalyticsIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Analytics"
                  {...a11yProps(3)}
                />
                <Tab
                  icon={
                    <span>
                      <ProfileIcon />
                    </span>
                  }
                  iconPosition="start"
                  label="Profile"
                  {...a11yProps(4)}
                />
              </Tabs>
            </Box>
          </Stack>
          <Box className={styles.closeDialogOuter}>
            <Button onClick={handleCloseQcLargeModal}>
              <img src={assest.crossGray} width={13} height={13} alt="icon" />
            </Button>
          </Box>
        </Stack>
        <Box className={styles.tabPanelWrap}>
          {/* <PerfectScrollbar> */}
          <TabPanel value={value} index={0}>
            <Box className={styles.tabHomeContainer}>
              <Stack
                direction={"row"}
                flexWrap={"wrap"}
                alignItems={"center"}
                className={styles.viewDateStack}
              >
                <Typography variant="body1">View data for</Typography>
                <Stack
                  direction={"row"}
                  flexWrap={"wrap"}
                  alignItems={"center"}
                  className={`${styles.showmonthyear} monthData`}
                >
                  {/* <Typography variant="caption" className={styles.monthFor}>
                        Month
                      </Typography>
                      <Typography variant="caption" className={styles.yearFor}>
                        Year
                      </Typography> */}
                  <SelectMonth sendDataToParent={handleChildData} />
                  <SelectYear sendDataToParent={handleChildData} />
                </Stack>
              </Stack>
              <Box className={styles.tabHomeCardGroup}>
                <Grid
                  container
                  rowSpacing={0}
                  columnSpacing={{ xs: 1, sm: 2, md: 6.25 }}
                >
                  {/* {cardGridLoop.map((item, index) => {
                        return (
                          <Grid item md={6}>
                            <VideosummaryCard
                              videoTitle={item?.videoTitle}
                              countVideo={""}
                            >
                              <List>
                                {item.children.map((subItem) => {
                                  return (
                                    <ListItem>
                                      <Typography variant="body1">
                                        {subItem?.listName}
                                      </Typography>
                                      <Typography variant="caption">
                                        {subItem?.videoCount}
                                      </Typography>
                                    </ListItem>
                                  );
                                })}
                              </List>
                              <Image
                                src={assest.submissionSummeryImg}
                                width={36}
                                height={36}
                                alt=""
                                className={styles.watermark}
                              />
                            </VideosummaryCard>
                          </Grid>
                        );
                      })} */}
                  <Grid item md={6}>
                    <VideosummaryCard
                      videoTitle={"Validation Summary"}
                      countVideo={""}
                    >
                      <List>
                        <ListItem>
                          <Typography variant="body1">All videos</Typography>
                          <Typography variant="caption">
                            {
                              submissionsListData?.data?.validate_summary
                                ?.all_validated_videos
                            }
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">Confirmed</Typography>
                          <Typography variant="caption">
                            {
                              submissionsListData?.data?.validate_summary
                                ?.confirmed_decision
                            }
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">Denied</Typography>
                          <Typography variant="caption">
                            {
                              submissionsListData?.data?.validate_summary
                                ?.denied_decision
                            }
                          </Typography>
                        </ListItem>
                      </List>
                      <img
                        src={assest.submissionSummeryImg}
                        width={36}
                        height={36}
                        alt=""
                        className={styles.watermark}
                      />
                    </VideosummaryCard>
                  </Grid>
                  <Grid item md={6}>
                    <VideosummaryCard
                      videoTitle={"Pending Validation"}
                      countVideo={""}
                    >
                      <List>
                        <ListItem>
                          <Typography variant="body1">Approved</Typography>
                          <Typography variant="caption">
                            {props.counts?.pending_validation?.approved}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">Website Only</Typography>
                          <Typography variant="caption">
                            {props.counts?.pending_validation?.website_only}
                          </Typography>
                        </ListItem>
                        <ListItem>
                          <Typography variant="body1">Rejected</Typography>
                          <Typography variant="caption">
                            {props.counts?.pending_validation?.rejected}
                          </Typography>
                        </ListItem>
                      </List>
                      <img
                        src={assest.submissionSummeryImg}
                        width={36}
                        height={36}
                        alt=""
                        className={styles.watermark}
                      />
                    </VideosummaryCard>
                  </Grid>
                </Grid>
              </Box>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box className={styles.fluidSec}>
              <Box className="tabWrapper">
                <Tabs
                  value={innerTab}
                  onChange={handleChange2}
                  aria-label="basic tabs example"
                >
                  <Tab
                    label={
                      <>
                        <span>Approved</span>
                        <TabArrowIcon />
                        <span>Approved</span>
                      </>
                    }
                    {...a11yProps(5)}
                  />
                  <Tab
                    label={
                      <>
                        <span>Website Only</span>
                        <TabArrowIcon />
                        <span>Website Only</span>
                      </>
                    }
                    {...a11yProps(6)}
                  />
                  <Tab
                    label={
                      <>
                        <span>Rejected</span>
                        <TabArrowIcon />
                        <span>Rejected</span>
                      </>
                    }
                    {...a11yProps(7)}
                  />
                </Tabs>
              </Box>
              <Box className={styles.qcTable}>
                <Paper
                  className={`${styles.tablePaper} ${styles.tableQCPaper}`}
                >
                  {/* <TabPanel value={innerTab} index={0}>
                      <ModaltableHeader
                        allVideo={true}
                        searchType={true}
                        pendingBtn={false}
                        filterBtn={true}
                      />
                      <Box className={styles.tableResponsive}>
                        <QcModalTable />
                        <Box className={styles.innerPagination}>
                          <Pagination
                            lastpage={undefined}
                            onClick={undefined}
                            sendDataToParent={undefined}
                          />
                        </Box>
                      </Box>
                    </TabPanel>
                    <TabPanel value={innerTab} index={1}>
                      <ModaltableHeader
                        allVideo={true}
                        searchType={true}
                        pendingBtn={false}
                        filterBtn={true}
                      />
                      <Box className={styles.tableResponsive}>
                        <QCModalWebsiteonlyTable />
                        <Box className={styles.innerPagination}>
                          <Pagination
                            lastpage={undefined}
                            onClick={undefined}
                            sendDataToParent={undefined}
                          />
                        </Box>
                      </Box>
                    </TabPanel>
                    <TabPanel value={innerTab} index={2}>
                      <ModaltableHeader
                        allVideo={true}
                        searchType={true}
                        pendingBtn={false}
                        filterBtn={true}
                      />
                      <Box className={styles.tableResponsive}>
                        <QCModalRejectedTable />
                        <Box className={styles.innerPagination}>
                          <Pagination
                            lastpage={undefined}
                            onClick={undefined}
                            sendDataToParent={undefined}
                          />
                        </Box>
                      </Box>
                    </TabPanel> */}

                  <QcConfirmVideo
                    innerTab={innerTab}
                    selectedId={dasda}
                    name={props?.name}
                  />
                </Paper>
              </Box>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={2}>
            <Box className={styles.fluidSec}>
              <Box className="tabWrapper deniedVideo">
                <PerfectScrollbar>
                  <Tabs
                    value={dinedTab}
                    onChange={handleChange3}
                    aria-label="basic tabs example"
                  >
                    <Tab
                      label={
                        <>
                          <span>Approved</span>
                          <TabArrowIcon />
                          <span>Rejected</span>
                        </>
                      }
                      {...a11yProps(8)}
                    />
                    <Tab
                      label={
                        <>
                          <span>Approved</span>
                          <TabArrowIcon />
                          <span>Website Only</span>
                        </>
                      }
                      {...a11yProps(9)}
                    />
                    <Tab
                      label={
                        <>
                          <span>Rejected</span>
                          <TabArrowIcon />
                          <span>Approved</span>
                        </>
                      }
                      {...a11yProps(10)}
                    />
                    <Tab
                      label={
                        <>
                          <span>Rejected</span>
                          <TabArrowIcon />
                          <span>Website Only</span>
                        </>
                      }
                      {...a11yProps(11)}
                    />
                    <Tab
                      label={
                        <>
                          <span>Website Only</span>
                          <TabArrowIcon />
                          <span>Approved</span>
                        </>
                      }
                      {...a11yProps(12)}
                    />
                    <Tab
                      label={
                        <>
                          <span>Website Only</span>
                          <TabArrowIcon />
                          <span>Rejected</span>
                        </>
                      }
                      {...a11yProps(13)}
                    />
                  </Tabs>
                </PerfectScrollbar>
              </Box>
              <Box className={styles.qcTable}>
                <Paper
                  className={`${styles.tablePaper} ${styles.tableQCPaper}`}
                >
                  <QcDeniedVideo
                    innerTab={dinedTab}
                    selectedId={dasda}
                    name={props?.name}
                  />
                  {/* <TabPanel value={dinedTab} index={0}>
                      <ModaltableHeader
                        allVideo={true}
                        searchType={true}
                        pendingBtn={false}
                        filterBtn={true}
                      />
                      <Box className={styles.tableResponsive}>
                        <QCModalDeniedApprovedRejectedTable />
                        <Box className={styles.innerPagination}>
                          <Pagination
                            lastpage={undefined}
                            onClick={undefined}
                            sendDataToParent={undefined}
                          />
                        </Box>
                      </Box>
                    </TabPanel>
                    <TabPanel value={dinedTab} index={1}>
                      <ModaltableHeader
                        allVideo={true}
                        searchType={true}
                        pendingBtn={false}
                        filterBtn={true}
                      />
                      <Box className={styles.tableResponsive}>
                        <QCModalDeniedApprovedwebsiteTable />
                        <Box className={styles.innerPagination}>
                          <Pagination
                            lastpage={undefined}
                            onClick={undefined}
                            sendDataToParent={undefined}
                          />
                        </Box>
                      </Box>
                    </TabPanel>
                    <TabPanel value={dinedTab} index={2}>
                      <ModaltableHeader
                        allVideo={true}
                        searchType={true}
                        pendingBtn={false}
                        filterBtn={true}
                      />
                      <Box className={styles.tableResponsive}>
                        <QCModalDeniedRejectedApprovedTable />
                        <Box className={styles.innerPagination}>
                          <Pagination
                            lastpage={undefined}
                            onClick={undefined}
                            sendDataToParent={undefined}
                          />
                        </Box>
                      </Box>
                    </TabPanel>
                    <TabPanel value={dinedTab} index={3}>
                      <ModaltableHeader
                        allVideo={true}
                        searchType={true}
                        pendingBtn={false}
                        filterBtn={true}
                      />
                      <Box className={styles.tableResponsive}>
                        <QCModalDeniedRejectedwebsiteTable />
                        <Box className={styles.innerPagination}>
                          <Pagination
                            lastpage={undefined}
                            onClick={undefined}
                            sendDataToParent={undefined}
                          />
                        </Box>
                      </Box>
                    </TabPanel>
                    <TabPanel value={dinedTab} index={4}>
                      <ModaltableHeader
                        allVideo={true}
                        searchType={true}
                        pendingBtn={false}
                        filterBtn={true}
                      />
                      <Box className={styles.tableResponsive}>
                        <QCModalDeniedWebsiteApprovedTable />
                        <Box className={styles.innerPagination}>
                          <Pagination
                            lastpage={undefined}
                            onClick={undefined}
                            sendDataToParent={undefined}
                          />
                        </Box>
                      </Box>
                    </TabPanel>
                    <TabPanel value={dinedTab} index={5}>
                      <ModaltableHeader
                        allVideo={true}
                        searchType={true}
                        pendingBtn={false}
                        filterBtn={true}
                      />
                      <Box className={styles.tableResponsive}>
                        <QCModalDeniedWebsiteRejectedTable />
                        <Box className={styles.innerPagination}>
                          <Pagination
                            lastpage={undefined}
                            onClick={undefined}
                            sendDataToParent={undefined}
                          />
                        </Box>
                      </Box>
                    </TabPanel> */}
                </Paper>
              </Box>
            </Box>
          </TabPanel>
          <TabPanel value={value} index={3}>
            <Stack
              direction={"row"}
              className={`${styles.editorBody} ${styles.modalEditorBody} ${styles.qcAnalyticsBody}`}
            >
              <Box className={styles.SecFilter}>
                <NotificationLeftFilter filterType={"copywriter"} />
              </Box>
              <Box className={`${styles.analyticsBoxes}`}>
                <Box className={styles.inneranalytics}>
                  <Grid
                    container
                    rowSpacing={0}
                    columnSpacing={{ xs: 1, sm: 2, md: 6.25 }}
                  >
                    {analyticsLoop.map((item, index) => {
                      return (
                        <Grid item md={6}>
                          <VideosummaryCard
                            videoTitle={item?.videoTitle}
                            countVideo={item?.countVideo}
                          >
                            <TableContainer>
                              <Table>
                                <TableBody>
                                  {item.children.map((subItem) => {
                                    return (
                                      <TableRow>
                                        <TableCell className={styles.trOne}>
                                          <Typography variant="body1">
                                            {subItem?.listName}
                                          </Typography>
                                        </TableCell>
                                        <TableCell className={styles.trTwo}>
                                          <figure>
                                            <LongArrowIcon />
                                          </figure>
                                        </TableCell>
                                        <TableCell className={styles.trThree}>
                                          <Typography variant="body1">
                                            {subItem?.listname2}
                                          </Typography>
                                        </TableCell>
                                        <TableCell
                                          align="right"
                                          className={styles.trFour}
                                        >
                                          <Typography variant="caption">
                                            {subItem?.videoCount}
                                          </Typography>
                                        </TableCell>
                                      </TableRow>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </VideosummaryCard>
                        </Grid>
                      );
                    })}
                  </Grid>
                </Box>
              </Box>
            </Stack>
          </TabPanel>
          <TabPanel value={value} index={4}>
            <Stack
              direction={"row"}
              className={`${styles.editorProfileTab} ${styles.qcProfileTab}`}
            >
              <Box className={styles.PfsecLeft}>
                <QcUserCreateTab
                  userdata={props.fullitem} // forgotTitle={"QC Agent Forgot his Password?"}
                  forgotText={"for_manager"}
                  accountSubmission={false} // lastActive={true}
                />
              </Box>
              <Box className={styles.pfSecRight}>
                <TipaltiPartnerCard />
              </Box>
            </Stack>
          </TabPanel>
          {/* </PerfectScrollbar> */}
        </Box>
      </EditorsLargeModal>

      {/* ================================================================= */}
      {/* ============== FOR QC AGENTS PAGE MODAL DESIGN END ============== */}
    </>
  );
};

export default SearchEditorCard;
